import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { userSelectorSelector } from '../UserSelector/reducers/UserSelectorReducer';
import { ClassificationSelector, setClassificationResults, setOrderBy, setOrderDirection } from './reducers/ClassificationReducer';
import DatatableColumnModel from '../Datatable/DatatableColumnModel';
import ClassificationModel from './models/ClassificationModel';
import Utility from '../../app/utility';
import Datatable, { PagingTypeEnum } from '../Datatable/Datatable';
import { Grid, Button } from '@mui/material';
import Api from '../../app/apiRequest';
import { setShowInputBrokerAccountPanel } from '../BrokerAccount/reducers/BrokerAccountSearchReducer';
import { setShowQuickSummaryModal } from '../FixtureManagement/components/FixtureQuickSummary/reducers/FixtureQuickSummaryReducer';
import { setHideInvoice, setHideEva, resetFixtureInput, setSelectedFixtureId, setTriggerFocusChartererInput, setShowInputPanel, setIsEditFixture } from '../FixtureManagement/reducers/FixtureInputReducer';
import { GetClassificationsParam } from '../Care/api/CareApi';
import { OrderDirection } from '../Datatable/OrderDirection';

const ClassificationTable: React.FunctionComponent = () => {
    let dispatch = useDispatch();
    const ClassificationData = useSelector(ClassificationSelector);
    const userSelectorData = useSelector(userSelectorSelector);

    const columns = [
        {
            Field: Utility.propertyOf<ClassificationModel>("clientName"),
            Title: "Client",
            AllowSort: true,
        } as DatatableColumnModel<ClassificationModel>,
        {
            Field: Utility.propertyOf<ClassificationModel>("comm"),
            Title: "Comm",
            AllowSort: true,
            Render: (rowData: ClassificationModel) => (
                <>
                    {rowData.comm.toFixed(2)}
                </>
            )
        } as DatatableColumnModel<ClassificationModel>,
        {
            Field: Utility.propertyOf<ClassificationModel>("frequency"),
            Title: "Frequency",
            AllowSort: true,
        } as DatatableColumnModel<ClassificationModel>,
        {
            Field: Utility.propertyOf<ClassificationModel>("recency"),
            Title: "Recency",
            AllowSort: true,
        } as DatatableColumnModel<ClassificationModel>,
        {
            Field: Utility.propertyOf<ClassificationModel>("commRank"),
            Title: "Comm Rank",
            AllowSort: true,
        } as DatatableColumnModel<ClassificationModel>,
        {
            Field: Utility.propertyOf<ClassificationModel>("frequencyRank"),
            Title: "Frequency Rank",
            AllowSort: true,
        } as DatatableColumnModel<ClassificationModel>,
        {
            Field: Utility.propertyOf<ClassificationModel>("recencyRank"),
            Title: "Recency Rank",
            AllowSort: true,
        } as DatatableColumnModel<ClassificationModel>,
        {
            Field: Utility.propertyOf<ClassificationModel>("classification"),
            Title: "Classification",
            AllowSort: true,
        } as DatatableColumnModel<ClassificationModel>,
    ];

    return <>
        <Grid
            container
            justifyContent="flex-end"
            className="table-search-result-utility-bar"
        >
            <Grid>
                <Button
                    color="secondary"
                    variant='outlined'
                    className='table-search-result-utility-bar-item'
                    onClick={() => {
                        let url = Api.constructGetUrl("/api/Care/ExportClassifications", {
                            searchDate: ClassificationData.query.searchDate
                        } as GetClassificationsParam);

                        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                        if (newWindow) newWindow.opener = null
                    }}
                >Export Excel</Button>
            </Grid>
        </Grid>
        <Datatable<ClassificationModel>
            useCheckBox={false}
            className='classification-datatable-search-result nice-scroll'
            useDefaultSearchBar={false}
            pagingType={PagingTypeEnum.None}
            data={ClassificationData.searchResults}
            useItemPerPage={false}
            columns={columns}
            isDataLoaded={true}
            useHeaderSort={true}
            stickyHeader={true}
            onOrderDirectionChange={(column: DatatableColumnModel<ClassificationModel>, orderDirection: OrderDirection) => {
                let classifications = orderDirection == OrderDirection.Asc ?
                    _.sortBy(ClassificationData.searchResults, column.Field) :
                    _.sortBy(ClassificationData.searchResults, column.Field).reverse();

                dispatch(setClassificationResults(classifications));

                dispatch(setOrderBy(column.Field));
                dispatch(setOrderDirection(orderDirection));

            }}
            orderColumn={ClassificationData.orderBy}
            orderDirection={ClassificationData.orderDirection}
        ></Datatable>
    </>
};

export default ClassificationTable;